import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import BntStandard from '../PopUps/BntStandard';
import Standard16Ais from '../Button/ButtonCard/Standard16Ais';
import Standard8Aos from '../Button/ButtonCard/Standard8Aos';
import './Card.css';

/**
 * Standard component renders a card with standard I/O information.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Function} props.handleStdio - The callback function to handle standard I/O.
 * @param {Function} props.handleStdioDecrement16 - The callback function to decrement standard 16 I/O.
 * @param {Function} props.handleStdioDecrement8 - The callback function to decrement standard 8 I/O.
 * @param {Function} props.reset - The callback function to reset standard I/O.
 */
const Standard = ({
    /**
     * The callback function to handle standard I/O.
     */
    handleStdio,
    /**
     * The callback function to decrement standard 16 I/O.
     */
    handleStdioDecrement16,
    /**
     * The callback function to decrement standard 8 I/O.
     */
    handleStdioDecrement8,
    /**
     * The callback function to reset standard I/O.
     */
    reset
  }) => {
    const [open, setOpen] = useState(false);
  
    /**
     * Handles the click event to open the standard I/O popup.
     */
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    return (
      <Card variant="outlined" sx={{
        /**
         * Custom styles for the card container
         */
        width: '430px',
        height: '300px',
        marginLeft: '6.5%',
        border: 'none',
        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
      }}>
        <CardContent>
          <h3 style={{
            /**
             * Custom styles for the header
             */
            fontFamily: 'Open Sans',
            marginTop: '1%',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
          }}>
            Standard I/Os
          </h3>
          <p style={{
            /**
             * Custom styles for the paragraph
             */
            marginTop: '1%',
            fontFamily: 'Open Sans',
            fontSize: '12px',
            color: '#2b8cb9'
          }}>
            Select One
          </p>
          <div>
            <div style={{
              /**
               * Custom styles for the button container
               */
              marginBottom: '1%'
            }}>
              <Standard16Ais onClick={handleStdio} handleStdioDecrement={handleStdioDecrement16} reset={reset} />
            </div>
            <div>
              <Standard8Aos onClick={handleStdio} handleStdioDecrement={handleStdioDecrement8} reset={reset} />
            </div>
          </div>
          <p style={{
            /**
             * Custom styles for the paragraph
             */
            fontFamily: 'Open Sans',
            fontSize: '12px',
            marginLeft: '1%'
          }}>
            Board that provides a number of I/O interfaces.
          </p>
          <div style={{
            /**
             * Custom styles for the button container
             */
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
            <BntStandard size="small" onClick={handleClickOpen}>More Info</BntStandard>
          </div>
        </CardContent>
      </Card>
    );
  };
  
  /**
   * Exports the Standard component as the default export.
   */
  export default Standard;